import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  const { t } = useLang();
  useSeo({ title: "Pagina non trovata — De Los Cielos", description: "La pagina che cerchi non esiste o è stata spostata.", noindex: true });

  return (
    <div className="bg-obsidian text-cream min-h-screen flex flex-col" data-testid="not-found-page">
      <Nav />
      <section className="flex-1 flex items-center pt-32 pb-20">
        <div className="container-x">
          <Compass className="h-10 w-10 text-copper" />
          <p className="eyebrow mt-8">Errore 404</p>
          <h1 className="mt-4 font-serif font-semibold text-5xl sm:text-7xl leading-[0.95]">Fuori rotta</h1>
          <p className="mt-6 max-w-lg text-cream2 leading-relaxed">
            La pagina che cerchi non esiste o è stata spostata. Torna al punto di partenza o guarda le spedizioni aperte.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/" className="btn-copper" data-testid="not-found-home">
              Torna alla Home
            </Link>
            <Link to="/viaggi" className="btn-ghost" data-testid="not-found-tours">
              {t("nav.expeditions")} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
